const PALETTE = ['#d93025', '#e37400', '#188038', '#005040', '#9334e6', '#c2185b', '#00838f', '#5f6368', '#7b1fa2', '#0b8043']

/** Deterministic avatar color from a string. */
export function colorFor(s: string): string {
  let h = 0
  for (const ch of s) h = (h * 31 + ch.charCodeAt(0)) >>> 0
  return PALETTE[h % PALETTE.length]!
}

export function initials(name: string | null | undefined, address?: string | null): string {
  const src = (name || address || '?').trim()
  const parts = src.split(/[\s@._-]+/).filter(Boolean)
  return ((parts[0]?.[0] ?? '?') + (parts.length > 1 ? parts[1]![0]! : '')).toUpperCase()
}
